import React, { useState, useEffect } from "react";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  InputGroup,
  FormControl,
} from "react-bootstrap";
import ClaseIcon from "../assets/images/footer/user.svg";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

function Footer() {
  const [footerData, setFooterData] = useState(null);
  const [serviceData, setServiceData] = useState([]);

  
  const { pageResponse } = useSelector((state) => state.visitor);
  const { services } = useSelector((state) => state.service);

  useEffect(() => {
    if (pageResponse) {
      let footer = pageResponse.find((r) => r.code === "footer");
      setFooterData(footer.footer_section);
    }
  }, [pageResponse]);

  useEffect(() => {
    if (services) {
      setServiceData(services?.data);
    }
  }, [services]);

  return (
    <>
      <footer>
        <Container>
          <div className="footer-top">
            <Row>
              <Col sm="12" md="6" lg="4" xxl="3">
                <div className="footer-box">
                  <h3>Company</h3>
                  <ul>
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li>
                      <Link to="/about-us">About Us</Link>
                    </li>
                    <li>
                      <Link to="/blogs">Blogs</Link>
                    </li>
                    <li>
                      <Link to="/career">Careers</Link>
                    </li>
                    <li>
                      <Link to="/resources">Resources</Link>
                    </li>
                    <li>
                      <Link to="/contact-us">Contact Us</Link>
                    </li>
                  </ul>
                </div>
              </Col>
              <Col sm="12" md="6" lg="4" xxl="3">
                <div className="footer-box">
                  <h3>Our Services</h3>

                  {serviceData?.length > 0 && (
                    <ul>
                      {serviceData.map((row, index) => (
                        <li key={"n" + row.id + index}>
                          <Link to={"/service-details/" + row.slug}>
                            {row.title}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </Col>
              <Col sm="12" md="12" lg="4" xxl="3">
                <div className="footer-box">
                  <h3>Our Services</h3>
                  <Form>
                    <Form.Group controlId="locationInput">
                      <InputGroup>
                        <FormControl
                          placeholder="City & State or Zipcode"
                          aria-label="City & State or Zipcode"
                        />
                        <img src={ClaseIcon} alt="Close" />
                      </InputGroup>
                    </Form.Group>

                    <Form.Group controlId="careLevelSelect">
                      <Form.Select aria-label="Default select example">
                        <option>All Levels of Care</option>
                        <option value="1">Level 1</option>
                        <option value="2">Level 2</option>
                        <option value="3">Level 3</option>
                      </Form.Select>
                    </Form.Group>

                    <Button type="submit" className="w-100 custom-bttn">
                      Find a Care
                    </Button>
                  </Form>
                </div>
              </Col>
              <Col sm="12">
                <div className="disclaimer-box">
                  <h2>Disclaimer</h2>
                  <div
                    className=""
                    dangerouslySetInnerHTML={{ __html: footerData?.footer_header_text }}
                  ></div>

                </div>
              </Col>
            </Row>
          </div>
          <div className="footer-bottom">
            <Row>
              <Col sm="12" md="6">
                {/* <p>
                  © 2024 All Right Reserved by{" "}
                  <Link to="/legal-accessibility" title="Personal Care Inc.">
                    Personal Care Inc.
                  </Link>
                </p> */}
                <div
                    className=""
                    dangerouslySetInnerHTML={{ __html: footerData?.footer_copyright_text }}
                  ></div>
              </Col>
              <Col sm="12" md="6">
                <div className="footer-bottom-right">
                  <Link to="/legal" title="Legal">
                    Legal
                  </Link>
                  <Link to="/privacy-policy" title="Policy">
                    Policy
                  </Link>
                  <Link to="/terms-condition" title="Terms & Condition">
                    Terms & Condition
                  </Link>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </footer>
    </>
  );
}
export default Footer;
